import gql from 'graphql-tag'

export const GET_VEHICLE_VIDEO = gql`
  query VehicleVideo($filter: GetVehicleVideoFileInput!) {
    vehicleVideo(filter: $filter) {
      isSuccessful
      message
      vehicleVideo {
        mediaFilename
        isDownloaded
        startTime
        endTime
        channel
        imei
        url
        createdAt
      }
    }
  }
`

export const GET_VEHICLE_VIDEOS = gql`
  query VehicleVideos($filter: GetVehicleVideosFilter!) {
    vehicleVideos(filter: $filter) {
      isSuccessful
      message
      vehicleVideos {
        vehicleId
        lastUpdate
        files {
          mediaFilename
          isDownloaded
          channel
          startTime
          endTime
          imei
          url
          createdAt
        }
      }
    }
  }
`

export const GET_VEHICLE_VIDEOS_TV2 = gql`
  query VehicleVideos($filter: GetVehicleVideosFilter!) {
    vehicleVideos(filter: $filter) {
      isSuccessful
      message
      vehicleVideos {
        vehicleId
        lastUpdate
        deviceTimezone
        files {
          mediaFilename
          channel
          startTime
          endTime
          imei
          createdAt
        }
      }
    }
  }
`

export const GET_DEVICE_MEDIA = gql`
  query DeviceMedia($filter: DeviceMediaFilter!) {
    deviceMedia(filter: $filter) {
      isSuccessful
      message
      deviceMedia {
        vehicleId
        mediaFilename
        isDownloaded
        createdAt
      }
    }
  }
`

export const GET_DEVICE_STREAM = gql`
  query GetDeviceStream($filter: GetDeviceStreamFilter!) {
    getDeviceStream(filter: $filter) {
      isSuccessful
      message
      status
      getDeviceStream {
        message
      }
    }
  }
`

export const FIND_DOWNLOAD_VIDEO_HISTORIES_FOR_NOTIFICATION_MEDIA = gql`
  query FindDownloadVideoHistories($filter: FindDownloadHistoriesFilter!) {
    findDownloadVideoHistories(filter: $filter) {
      message
      isSuccessful
      status
      findDownloadVideoHistories {
        data {
          channel
          downloadOn
          mediaFilename
          status
          url
          identifier
          downloadId
        }
      }
    }
  }
`

export const GET_DOWNLOAD_VIDEO_HISTORIES = gql`
  query DownloadVideoHistories($filter: DownloadVideoHistoriesFilter) {
    downloadVideoHistories(filter: $filter) {
      message
      isSuccessful
      status
      downloadVideoHistories {
        pagination {
          page
          show
          startCursor
          endCursor
        }
        data {
          channel
          downloadId
          downloadOn
          endTime
          mediaFilename
          startTime
          status
          url
          identifier
          convertedChannel
          users {
            fullname
          }
          vehicle {
            hullNo
            id
            licensePlate
            parentVehicle {
              licensePlate
            }
            vehicleType {
              category
              type
            }
            device {
              timezone
              deviceCode
            }
          }
        }
      }
    }
  }
`

export const GET_THUMBNAIL_FOR_VIDEO_HISTORY = gql`
  query DownloadVideoHistories($filter: DownloadVideoHistoriesFilter) {
    downloadVideoHistories(filter: $filter) {
      message
      isSuccessful
      status
      downloadVideoHistories {
        pagination {
          page
          show
          startCursor
          endCursor
        }
        data {
          channel
          downloadId
          downloadOn
          endTime
          mediaFilename
          startTime
          status
          url
          identifier
          convertedChannel
        }
      }
    }
  }
`
